<div class="products-scanner">
  <button
    (click)="openBarcodeScanner()"
    class="button--text theme-primary-text-color"
    >
    <svg class="icon-scanner" height="32" viewBox="0 0 85 67.9" width="42">
      <use xlink:href="/images/icons/svg-sprite.svg#barcode-read"></use>
    </svg>
  </button>

  @if (applicationService.isShowBarcodeScannerPopup()) {
    <barcode-scanner
      (closed)="applicationService.onBarcodeScannerPopupCloseCallback()"
    ></barcode-scanner>
  }
</div>
